import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ArrowIcon from '../../img/icons/BBiconsRozbalit';

import './pagingComponent.scss';

const COLORS = {
    inactive: 'paging-component-inactive',
    active: 'paging-component-active'
};

const DOTS = '...';

class PagingComponent extends React.Component {
    static defaultProps = {
        alwaysShow: false,
        style: {}
    };

    static propTypes = {
        alwaysShow: PropTypes.bool,
        style: PropTypes.object
    };

    render() {
        return this.props.totalPages > 1 || this.props.alwaysShow === true ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: this.props.justify || 'flex-start', ...this.props.style }}>
                <div className="paging-component">
                    <ArrowIcon
                        className='paging-component-active-arrow '
                        style={{
                            ...{ width: '1.5em', height: '1.5em', transform: 'rotate(90deg)' },
                            ...(this.props.selectedPage === 1 ? {} : { cursor: 'pointer' })
                        }}
                        onClick={() => this.props.selectedPage !== 1 && this.props.setPage(this.props.selectedPage - 1)} />
                    {[this.computeFirstNumber, this.computeSecondNumber, this.computeThirdNumber, this.computeFourthNumber, this.computeFifthNumber]
                        .map((computeNumber, index) => {
                            return this.props.totalPages > index ? (
                                <span
                                    className={classnames(
                                        'paging-component-page',
                                        this.props.selectedPage === computeNumber(this.props.selectedPage, this.props.totalPages) ?
                                            COLORS.inactive : COLORS.active
                                    )}
                                    key={index}
                                    style={{
                                        ...{ fontWeight: 'bold' },
                                        ...(
                                            computeNumber(this.props.selectedPage, this.props.totalPages) === this.props.selectedPage ||
                                            computeNumber(this.props.selectedPage, this.props.totalPages) === DOTS
                                        ) ? {} : { cursor: 'pointer' }
                                    }}
                                    onClick={() =>
                                        computeNumber(this.props.selectedPage, this.props.totalPages) !== DOTS &&
                                        this.props.selectedPage !== computeNumber(this.props.selectedPage, this.props.totalPages) &&
                                        this.props.setPage(computeNumber(this.props.selectedPage, this.props.totalPages))}>
                                    {computeNumber(this.props.selectedPage, this.props.totalPages)}
                                </span>
                            ) : null;
                        })
                    }
                    <ArrowIcon
                        className='paging-component-active-arrow'
                        style={{
                            ...{ width: '1.5em', height: '1.5em', transform: 'rotate(-90deg)', marginRight:'.25em' },
                            ...(this.props.selectedPage >= this.props.totalPages ? {} : { cursor: 'pointer' })
                        }}
                        onClick={() => this.props.selectedPage < this.props.totalPages && this.props.setPage(this.props.selectedPage + 1)} />
                </div>
            </div>
        ) : null;
    }

    computeFirstNumber = () => 1;
    computeSecondNumber = (selectedPage, totalPages) => (totalPages <= 5 || selectedPage <= 3) ? 2 : DOTS;
    computeThirdNumber = (selectedPage, totalPages) => {
        if (totalPages <= 5 || selectedPage <= 3) {
            return 3;
        } else if (totalPages - selectedPage < 3) {
            return totalPages - 2;
        } else {
            return selectedPage;
        }
    }
    computeFourthNumber = (selectedPage, totalPages) => {
        if (totalPages <= 5)
            return 4;
        else if (totalPages - selectedPage < 3)
            return totalPages - 1;
        else
            return DOTS;
    }
    computeFifthNumber = (_, totalPages) => totalPages;
}

export default PagingComponent;